import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';
import {
  Col,
  Spinner,
  Modal,
  Button,
} from 'react-bootstrap';
import { useHistory, useLocation } from 'react-router-dom';
import InfiniteScroll from 'react-infinite-scroller';
import { useAuth } from '../../auth/Auth';
import { nextChallengeViewModel } from './next.challenge.viewmodel';
import { MY_ROOM_ROUTE } from '../../../constants/routes.constants';
import { bg } from '../../../constants/component.constants';
import { changeBodyClassName } from '../../../utils/utils';

import './scss/next.challenge.scss';
import CampHeaderDependant from '../../header/CampHeaderDependant';
import AddNextChallengeList from './AddNextChallengeList';

import { changeTextToVoice, getTaletreeFriendJson } from '../../../utils/camp.utils';
import Lottie from 'react-lottie-player';

const AddChallenges = (props, { challenge }) => {
  // const _PREVIOUS = 'previous';
  // const _CURRENT = 'current';
  // const _NEXT = 'upcoming';
  const _PAGE_LIMIT = 10;
  const _ALL = 'all';
  const _MOSTPOPULAR = 'most_popular';
  const _TAG = 'tag';
  const history = useHistory();
  const location = useLocation();

  const { dependent, guardian, fetchAPI } = useAuth();
  const [challengeList, setChallengeList] = useState(null);
  const [loading, setLoading] = useState(false);
  const [isOpen, setIsOpen] = useState(true)
  const userData = history.location.state.dependent;
  const [query, setQuery] = useState({
    limit: _PAGE_LIMIT,
    has_more: true,
    tags: location.state && location.state.tag ? location.state.tag : '',
    // availability:
    //   location.state && location.state.filter
    //     ? location.state.filter
    //     : _CURRENT,
  });
  const [tagList, setTagList] = useState([]);
  const [selectedTag, setSelectedTag] = useState(
    location.state && location.state.tag ? location.state.tag : []
  );
  const [selectedFilter, setSelectedFilter] = useState(
    location.state && location.state.filter ? location.state.filter : _ALL
  );
  const [allSelected, setAllSelected] = useState(true);
  const [mostPopularSelected, setMostPopularSelected] = useState(false);
  const [tagSelected, setTagSelected] = useState(false);
  const [isPlay, setIsPlay] = useState(false);
  const [isPaused, setIsPaused] = useState(false);

  // set selected filter
  useEffect(() => {
    setAllSelected(selectedFilter === _ALL);
    setMostPopularSelected(selectedFilter === _MOSTPOPULAR);
    setTagSelected(selectedFilter.split('_')[0] === _TAG);
    if (!loading) getChallenges();
  }, [selectedFilter]);

  // get all tags
  const getTagList = () => {
    fetchAPI(nextChallengeViewModel.getTags, { limit: 99 })
      .then((res) => {
        setTagList([...res]);
      })
      .catch((err) => { });
  };

  const getChallenges = () => {
    // setLoading(true);
    const previousChallengeList = challengeList;
    const filterStr =
      selectedFilter.split('_')[0] === _TAG ? _ALL : selectedFilter;

    const params = { ...query, 'dependent_id': dependent ? dependent.id : '' }

    fetchAPI(
      nextChallengeViewModel.getChallenges,
      filterStr,
      params,
      previousChallengeList
    )
      .then((data) => {
        ReactDOM.unstable_batchedUpdates(() => {
          setChallengeList(data.challengeList);
          setQuery(data.query);
        });
        setLoading(false);
      })
      .catch((error) => {
        // addError(error.data.message)
        // setLoading(false);
      });
  };


  useEffect(() => {
    changeBodyClassName([bg.CHALLENGES]);
    if (dependent && !dependent.profile.is_activated) {
      history.push({
        pathname: MY_ROOM_ROUTE,
        state: {
          from: "add_challenges"
        }
      })
      // window.location.reload();
    }
  }, []);

  const onItemClick = (e) => {
    const index = challengeList.findIndex((x) => {
      return x.id === parseInt(e.target.id, 10);
    });
    handleClick
    window.scrollTo(0, 0);
  };

  useEffect(() => {
    getTagList();
    setChallengeList(null);
  }, []);

  const closeModal = () => {
    setIsOpen(false);
  };

  const handleVoiceClick = () => {
    setIsPlay(!isPlay);
    const element = document.getElementById('voice-text')
    changeTextToVoice(element.textContent, isPlay, setIsPlay, isPaused, setIsPaused);
  }

  return (
    dependent ?
      <div className='add_challenges'>
        <CampHeaderDependant />
        <div className='add_challenges-inner'>
          <h1>Select Challenges</h1>
          <div className="flex justify-content-center">
            <div className="">
              <Col>
                {!loading && (
                  <>
                    <InfiniteScroll
                      pageStart={0}
                      loadMore={getChallenges}
                      hasMore={query.has_more}
                      loader={<Spinner key={0} animation="border" variant="info" />}
                      threshold={150}
                    >
                      <AddNextChallengeList
                        repos={challengeList}
                        handler={onItemClick}
                      />
                    </InfiniteScroll>
                    {/* <Row className="justify-content-md-center mt-4 pb-5">
                  
                  <button className="add-btn-interest go-to-room">GO TO YOUR ROOM!</button>
                  
                </Row> */}
                  </>
                )}
              </Col>
            </div>
          </div>
        </div>
        <Modal show={isOpen} className="signupPopup explore-challenges-modal mobile-v-popup auth-popup gardian auth-popup right-curved-div" centered>
          <Modal.Body>
            <div className='row bg-blue border-40'>
              <div className="col-md-6 col-lg-5 p-4 bg-blue border-left buble-relative overflow-hidden">
                <div className="voice-buble buuble-bounce" style={{ width: '200px' }}>
                  <p id='voice-text' >{dependent?.username}, based on your interests, we've selected some Challenges to explore.</p>
                </div>
                <div className="text-left">
                  {/* <p className="text-white voice-btn" onClick={handleVoiceClick}><BsVolumeUpFill /> Voice on</p> */}
                  <p className="" style={{marginTop: '9rem'}}>
                    {/* <Lottie
                      loop
                      animationData={getSoundWaveJson()}
                      play={isPlay}
                      className='animate-svg'
                    /> */}
                  </p>
                </div>
                <div className="cartoon-img">
                  <Lottie
                    loop={false}
                    animationData={getTaletreeFriendJson(dependent.profile.taletree_friend)}
                    play
                    className="w-100 cartoon-top"
                  />
                </div>
              </div>
              <div className="col-md-6 col-lg-7 bg-white border-right right-curve auth-section white-right-arrow">
                <p className="auth-entry-text">Explore Challenges</p>
                <p className="pb-250">Accept three of them to begin with and go to your Room.</p>

                <div className="text-center">
                  <Button className="gred-btn w-100" onClick={closeModal}>Select 3 challenges</Button>
                </div>

              </div>
            </div>
          </Modal.Body>
        </Modal>
      </div>
      : ""
  );
};

export default AddChallenges;
